import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import RootCauseSection from './components/RootCauseSection';
import SolutionSection from './components/SolutionSection';
import BeforeAfterSection from './components/BeforeAfterSection';
import ServiceSection from './components/ServiceSection';
import TrustSection from './components/TrustSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <RootCauseSection />
        <SolutionSection />
        <BeforeAfterSection />
        <ServiceSection />
        <TrustSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
